import React, { useState } from 'react'
import { useFindMenu, useTrans } from '@next-nx/hooks'
import { ArrowLeft } from '@next-nx/shared-ui/icons'
import { WContainer, Breadcrumbs, MainTitle, Button } from '@next-nx/shared-ui/atoms'
import { CittaAccordion } from '@next-nx/shared-ui/molecules'
import { ListingSeoText, Page, StoreLocatorHelpBanner } from '@next-nx/shared-ui/organisms'
import styles from './FilialiCittaTemplate.module.sass'
import { FilialeType, PaginaType } from '@next-nx/utils/types'
import _ from "lodash"


interface Props {
  filiali: FilialeType[]
  pagina?: PaginaType
}

const FilialiCittaTemplate = (props: Props) => {
  const { filiali, pagina = undefined } = props

  const t = useTrans()

  const regioni = filiali.length ? _.groupBy(_.sortBy(filiali, "regione"), "regione") : {}

  const helpBannerMenu = useFindMenu('help_banner')
  const helpBannerStoreLocatorMenu = useFindMenu('store-locator', helpBannerMenu)

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        {!!pagina?.breadcrumbs && (
          <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        )}
        {!!pagina?.titolo && <MainTitle label={pagina.titolo} className={styles.title} />}
        <div className={styles.backBox}>
          <Button
            label={t('Torna alla mappa')}
            icon={<ArrowLeft />}
            href={pagina?.breadcrumbs?.[1]?.url || "/store-locator"}
            variant="ghost"
          />
        </div>
        <div className={styles.list}>
          {Object.keys(regioni).map((key) => (
              <CittaAccordion regione={key} items={regioni[key]} key={key} className={styles.item} />
            ))}
        </div>
      </WContainer>
      {!!pagina?.descrizione && (
        <ListingSeoText text={pagina.descrizione} className={styles.seoText} />
      )}
      {helpBannerStoreLocatorMenu && (
        <StoreLocatorHelpBanner item={helpBannerStoreLocatorMenu} className={styles.banner} />
      )}
    </Page>
  )
}

export default FilialiCittaTemplate
